import { axiosAPI, responseHandler } from 'utils';

export default {
  getById(id) {
    return responseHandler(axiosAPI.get(`api/pending-registrations/${id}`));
  },

  precheck(id) {
    return responseHandler(
      axiosAPI.get(`api/pending-registrations/${id}/precheck`)
    );
  },

  finishRegistration(pendingRegistrationId, values) {
    return responseHandler(
      axiosAPI.post(
        `api/pending-registrations/${pendingRegistrationId}/finish`,
        values
      )
    );
  },

  emailStatus(params) {
    return responseHandler(
      axiosAPI.get(`api/landing-page/email-status`, { params })
    );
  },
};